import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import Img from "gatsby-image";

export default function ProductGallery(props) {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);

  const sliderRef = useRef(null);
  const navSliderRef = useRef(null);

  const slides = props.images ? props.images.filter(s => s && s.image) : null;

  useEffect(() => {
    setNav1(sliderRef.current);
    setNav2(navSliderRef.current);
  }, []);

  useEffect(() => {
    if (!props.selectedVariantCode || !slides || !sliderRef.current) return;
    const matchIndex = slides.findIndex(s =>
      s.variantCode && s.variantCode.split(',').map(v => v.trim()).includes(props.selectedVariantCode)
    );
    if (matchIndex === -1) return;
    sliderRef.current.slickGoTo(matchIndex);
    if (navSliderRef.current) navSliderRef.current.slickGoTo(matchIndex);
  }, [props.selectedVariantCode]);

  if (!slides || slides.length === 0) return null;

  return (
    <div>
      <Slider
        asNavFor={nav2}
        ref={sliderRef}
        arrows={false}
        dots={true}
        className="image-slider"
      >
        {slides.map(({ image }, i) => (
          <div key={"slider-" + i}>
            <Img fluid={image.localFile.childImageSharp.fluid} />
          </div>
        ))}
      </Slider>
      {slides.length > 1 && (
        <Slider
          asNavFor={nav1}
          ref={navSliderRef}
          slidesToShow={4}
          swipeToSlide={true}
          focusOnSelect={true}
          dots={false}
          arrows={true}
          infinite={false}
          className="slider-nav"
        >
          {slides.map(({ image }, i) => (
            <div key={"slider-nav-" + i}>
              <Img fluid={image.localFile.childImageSharp.fluid} />
            </div>
          ))}
        </Slider>
      )}
    </div>
  );
}
